// TODO выпилить при обогащении api монолита getContext цветами станций CD-68938
module.exports = [
  ["700579",[242,247,230,358,231,215,217,246,241,357,220,219,216,218,359]],
  ["800000",[38,50,159,78,86,123]],
  ["FFDF00",[1,365,363,338,66,337,361,76,243,366,362,90,350,95,339,367,364,129,351,352,152]],
  ["CF0000",[313,330,312,320,267,18,137,33,249,263,321,323,328,368,248,327,268,332,316,380,331,53,54,250,317,56,326,64,262,324,253,379,84,333,252,256,318,266,100,378,329,102,322,254,261,284,285,314,265,117,118,264,255,319,281,140,377,143,146,149,325,156,269,315]],
  ["D70834",[183,169,180,177,173,168,167,182,184,172,181,176,174,171,170,185,178,179,175]],
  ["00701A",[2,245,9,369,15,259,348,29,30,346,36,344,39,260,43,45,49,52,258,342,68,77,82,85,345,257,340,106,251,116,124,125,283,341,343,349,144,347]],
  ["FF7F00",[3,5,10,16,21,27,42,47,51,63,69,19,79,80,103,104,107,111,121,127,132,151,158]],
  ["009BD5",[4,11,35,272,62,70,93,120,141,142]],
  ["A2A5B5",[6,7,17,20,24,28,37,71,73,74,75,83,98,99,110,112,114,128,131,135,145,147,148,157]],
  ["7ACDCE",[392,26,390,393,389,395,44,387,381,396,394,388,384,386,385,397,391,383]],
  ["FA6F9E",[302,293,298,307,306,290,300,294,308,295,299,310,303,304,291,309,297,301,292,305,289,311]],
  ["03238B",[8,13,336,335,234,41,334,46,57,60,61,235,72,233,87,88,89,96,244,113,229,115,360,228,153,155]],
  ["94007C",[12,14,31,34,270,282,58,59,271,81,94,97,101,105,109,275,122,126,133,134,154]],
  ["069857",[355,205,206,210,211,207,356,213,208,204,212,214]],
  ["ACBFE3",[274,23,25,273,136,138,139]],
  ["8AD02A",[240,22,287,353,32,237,40,239,48,55,399,65,236,67,296,91,92,108,354,119,130,398,286,150,238]],
  ["0177BF",[277,279,278,280,276]],
  ["DF6E08",[382,221,225,222,224,226,232,227]],
  ["087DCD",[193,202,203,201,198,194,188,200,186,192,190,187,195,189,197,191,199]],
  ["DB0A5B",[370,372,373,375,376,371,374]]
];
